"use client"
/* */
import { useContextSlot } from '../../../lib/slotContext/useContextSlot.mjs';
import { getActionGroupSlot } from '../../ActionGroup/lib/getActionGroupSlot.mjs';

const useConfirmationModalButtonSlot = (props) => {
  const inConfirmationModal = useContextSlot("Modal") === "actionConfirm";
  return inConfirmationModal ? getActionGroupSlot(props) : void 0;
};

export { useConfirmationModalButtonSlot };
//# sourceMappingURL=useConfirmationModalButtonSlot.mjs.map
